import * as t from "io-ts";
export const driverNotebookT = t.strict({
    id: t.string,
    name: t.string,
    content: t.string,
});
export const driverNotebooksT = t.array(driverNotebookT);
export const driverNotebookPostT = t.strict({
    name: t.string,
});
export const driverNotebookPutT = t.strict({
    content: t.string,
});
//# sourceMappingURL=driver-notebooks.js.map